import { useState, useMemo, useContext, createContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_LOGGED_IN_USER } from '~/lib/get-logged-in-user'

export const LoggedInUserContext = createContext()
export const LoggedInUserConsumer = LoggedInUserContext.Consumer

function LoggedInUserProvider({ children, data = {} }) {
  const { deviceInfo = {}, currentUrl } = data
  const [email, setEmail] = useState(null)
  const [createTicketAlertHandler, setCreateTicketAlertHandler] = useState(null)
  const { data: queryData } = useQuery(GET_LOGGED_IN_USER)
  const { loggedInUser = null } = queryData || {}

  const value = useMemo(() => {
    return {
      loggedInUser,
      deviceInfo,
      currentUrl,
      email,
      setEmail,
      createTicketAlertHandler,
      setCreateTicketAlertHandler,
    }
  }, [loggedInUser, deviceInfo, email, createTicketAlertHandler, currentUrl])

  return <LoggedInUserContext.Provider value={value}>{children}</LoggedInUserContext.Provider>
}

export function useLoggedInUser() {
  const context = useContext(LoggedInUserContext)
  if (!context) {
    throw new Error('useLoggedInUser() must be used within a LoggedInUserProvider')
  }
  const { loggedInUser, deviceInfo, currentUrl } = context
  return {
    loggedInUser,
    deviceInfo,
    currentUrl,
  }
}

export default LoggedInUserProvider
